var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-footer hidden-small"},[_c('a',{attrs:{"data-toggle":"tooltip","data-placement":"top","title":"Logout","href":"#"},on:{"click":function($event){return _vm.logout()}}},[_c('span',{staticClass:"glyphicon glyphicon-off",attrs:{"aria-hidden":"true"}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }